import React from "react";
import styled from "styled-components";

import {
  RichContentDisplay,
  RichContentDisplayProps,
} from "@examspark/common-ui";

type UnitContentProps = RichContentDisplayProps;

/**
 * Produces pretty typographics consistently across Bonfire.
 */
const UnitContent = (props: UnitContentProps) => {
  return (
    <UnitContentWrapper>
      <RichContentDisplay {...props} />
    </UnitContentWrapper>
  );
};

const BaseContentWrapper = styled.div`
  color: #222;
  line-height: 1.6em;
  font-size: 1.3rem;

  & > div > p:first-child {
    margin-top: 0;
  }
  & > div > p:last-child {
    margin-bottom: 0;
  }

  overflow: hidden;

  & img {
    max-width: 100%;
  }

  // ensure long url's don't break the layout
  word-break: break-word;

  figure {
    margin: 0;
    padding: 0;
  }

  blockquote {
    padding: 1rem;
    border: solid 2px #000;
    margin: 1rem 0;
  }
`;

const UnitContentWrapper = styled(BaseContentWrapper)``;
const TCRUnitContentWrapper = styled(BaseContentWrapper)`
  table {
    width: 100%;
    border-spacing: 0;
    border-collapse: collapse;

    tr > td:first-child {
      ol {
        margin: 0;
        padding: 0;
        list-style: none;
      }
    }
  }
`;

/**
 * Hack: handle pasted TCR lessons tables
 */
export const TCRUnitContent = (props: UnitContentProps) => {
  return (
    <TCRUnitContentWrapper>
      <RichContentDisplay {...props} />
    </TCRUnitContentWrapper>
  );
};

UnitContent.Wrapper = UnitContentWrapper;

export default UnitContent;
